/**
 * 视频灯箱：全屏播放
 *
 * 仅用于 Canvas 里点击当前任务卡时的"全屏看大图"，
 * 不再承载"填充提示词 / 填充参考图"功能（这些按钮已经移到 Canvas 的选中预览卡片下方）。
 */

import { X } from 'lucide-react';
import { useEffect } from 'react';
import { withAuthToken } from '../../../utils/storageUrl';

interface VideoLightboxProps {
  videoUrl: string | null;
  coverUrl?: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function VideoLightbox({ videoUrl, coverUrl, isOpen, onClose }: VideoLightboxProps) {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen || !videoUrl) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        type="button"
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20"
        onClick={onClose}
      >
        <X className="w-5 h-5" />
      </button>
      <div
        className="max-w-5xl max-h-[85vh] w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <video
          src={withAuthToken(videoUrl)}
          poster={withAuthToken(coverUrl) || undefined}
          controls
          autoPlay
          className="w-full h-full max-h-[85vh] object-contain rounded-2xl"
        />
      </div>
    </div>
  );
}
